module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect--dark-520b4ee4643dc2bb852bfdb8a7dacc61.png";